import request from '@/utils/request'

export const getCity = ({ code }) => {
  return request({
    url: `/upms/citycode/parent/${code}`
  })
}
